export function isDisplayIdVerified(typedValue, displayId) {
  if (displayId == null || typedValue == null) {
    return false
  }

  return String(typedValue).trim() === String(displayId)
}

export function canSubmitManagementCompanyChange({
  isSubmitting,
  isLoadingMerchants,
  selectedMerchantId,
  typedDisplayId,
  displayId
}) {
  return (
    !isSubmitting &&
    !isLoadingMerchants &&
    !!selectedMerchantId &&
    isDisplayIdVerified(typedDisplayId, displayId)
  )
}

export function buildMigrationSummaryItems(result, fallbackDisplayId) {
  const oldDisplayId = result?.sourceDisplayId ?? fallbackDisplayId
  const newDisplayId = result?.targetDisplayId

  return [
    {
      label: 'Old DisplayId',
      value: oldDisplayId != null ? `#${oldDisplayId}` : '-'
    },
    {
      label: 'New DisplayId',
      value: newDisplayId != null ? `#${newDisplayId}` : '-'
    },
    {
      label: 'New management company ID',
      value: result?.newMerchantId != null ? String(result.newMerchantId) : '-'
    },
    {
      label: 'Users moved',
      value: String(result?.subsidiaryDashboardUsersMoved ?? 0)
    },
    {
      label: 'User configs moved',
      value: String(result?.dashboardUserConfigurationsMoved ?? 0)
    },
    {
      label: 'Invoices moved',
      value: String(result?.invoicesMoved ?? 0)
    },
    {
      label: 'Payments moved',
      value: String(result?.paymentsMoved ?? 0)
    },
    {
      label: 'Period configs kept on both hotels',
      value: String(result?.periodConfigsCopied ?? 0)
    },
    {
      label: 'Prepay rate options kept on both hotels',
      value: String(result?.prepayRateOptionsCopied ?? 0)
    },
    {
      label: 'Prepay period histories kept on both hotels',
      value: String(result?.prepayPeriodHistoriesCopied ?? 0)
    }
  ]
}

